/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlayRouteImport } from './routes/play'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as JoinCodeRouteImport } from './routes/join.$code'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinCodeRoute = JoinCodeRouteImport.update({
  id: '/join/$code',
  path: '/join/$code',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/play': typeof PlayRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/stats': typeof StatsRoute
  '/join/$code': typeof JoinCodeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/play': typeof PlayRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/stats': typeof StatsRoute
  '/join/$code': typeof JoinCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/play': typeof PlayRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/stats': typeof StatsRoute
  '/join/$code': typeof JoinCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/play' | '/rules' | '/settings' | '/stats' | '/join/$code'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/play' | '/rules' | '/settings' | '/stats' | '/join/$code'
  id:
    | '__root__'
    | '/'
    | '/play'
    | '/rules'
    | '/settings'
    | '/stats'
    | '/join/$code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PlayRoute: typeof PlayRoute
  RulesRoute: typeof RulesRoute
  SettingsRoute: typeof SettingsRoute
  StatsRoute: typeof StatsRoute
  JoinCodeRoute: typeof JoinCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats': {
      id: '/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$code': {
      id: '/join/$code'
      path: '/join/$code'
      fullPath: '/join/$code'
      preLoaderRoute: typeof JoinCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PlayRoute: PlayRoute,
  RulesRoute: RulesRoute,
  SettingsRoute: SettingsRoute,
  StatsRoute: StatsRoute,
  JoinCodeRoute: JoinCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
